import { type Settings } from '@/settings';

import { currentOrigin } from './currentOrigin';

/** staging settings overrides */
export const settings: Partial<Settings> = {
  BASE_API_ORIGIN: currentOrigin(),
  CSRF_COOKIE_NAME: '__Host-evolveappstorecsrfstaging',
  GOOGLEMAPS_API_KEY: '',
};

export default settings;
